
const TextMessage = ({
  message
}) =>
{
  const { text_body } = message
  return String(text_body)
    .split('\n')
    .map((line, idx) => <div key={idx}>{ line }</div>)
}

export default TextMessage
